"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("./theme");
const Button_1 = __importDefault(require("./Button"));
/** Error message + optional retry button. Use for failed fetches (e.g. Calendar, list pages) instead of inline error blocks. */
const ErrorState = ({ message, onRetry, retryLabel = 'Retry', style, }) => ((0, jsx_runtime_1.jsxs)("div", { style: {
        padding: 40,
        background: theme_1.theme.colors.errorBg,
        borderRadius: 12,
        textAlign: 'center',
        color: theme_1.theme.colors.errorText,
        border: `1px solid ${theme_1.theme.colors.errorText}`,
        ...style,
    }, role: "alert", children: [(0, jsx_runtime_1.jsx)("p", { style: { margin: 0, fontSize: 16, fontWeight: 600 }, children: message }), onRetry && ((0, jsx_runtime_1.jsx)(Button_1.default, { type: "button", variant: "secondary", onClick: onRetry, style: { marginTop: 16 }, children: retryLabel }))] }));
exports.default = ErrorState;
